
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-centre",
      function () {
        return require("private-next-pages/all-centre/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-centre"])
      });
    }
  